import { db } from '../db/dexie';

/**
 * Everything, as one JSON file. Image binaries are excluded — attachment
 * metadata carries the storage path, and the bytes themselves already exist on
 * both devices. Keeping them out is what makes the export small enough to
 * actually take, which is the only property an export needs.
 */
export async function exportJSON() {
  const [items, lists, listTags, globalTags, attachments] = await Promise.all([
    db.items.toArray(),
    db.lists.toArray(),
    db.listTags.toArray(),
    db.globalTags.toArray(),
    db.attachments.toArray(),
  ]);

  const payload = {
    app: 'SlippingNotes',
    version: 3,
    exported_at: new Date().toISOString(),
    items: items.map(strip),
    lists: lists.map(strip),
    list_tags: listTags.map(strip),
    global_tags: globalTags.map(strip),
    attachments: attachments.map(strip),
  };

  const blob = new Blob([JSON.stringify(payload, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `slippingnotes-${new Date().toISOString().slice(0, 10)}.json`;
  a.click();
  URL.revokeObjectURL(url);
  return payload;
}

/** `dirty` is a local sync flag; it means nothing outside this device. */
function strip<T extends { dirty: 0 | 1 }>(row: T) {
  const { dirty: _dirty, ...rest } = row;
  return rest;
}
